import { PocDivider } from 'commons/components/components-wrapper';
import styled from 'styled-components';

export const HorizontalDivider = styled(PocDivider)``;
